import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FilterDTO,
  FilterOperator,
  ParkerClient,
  SortDirection,
} from '../../../base/models/models.swagger.generated';
import { IAutocompleteItem } from '../../../base/shared/autocomplete/autocomplete-item';
import { AutocompleteComponent } from '../../../base/shared/autocomplete/autocomplete.component';
import { searchScore } from '../../../base/shared/autocomplete/search-score';

const PARKER_FULL_NAME_FIELD = 'FullName';

@Component({
  selector: 'app-parker-name-autocomplete',
  template: `
    <app-autocomplete
      [getDataFunction]="searchParkerNames.bind(this)"
      [value]="value"
      (valueChange)="valueChange.emit($event ?? null)"
      [placeholder]="placeholder"
      [autoSelectOnSingleResult]="true">
    </app-autocomplete>
  `,
  imports: [AutocompleteComponent],
})
export class ParkerNameAutocompleteComponent {
  @Input() clientId?: number;
  @Input() value: string | null;
  @Input() placeholder = 'i18n.domain.parker-registration.filter.parker-name';
  @Output() valueChange = new EventEmitter<string | null>();

  constructor(private parkerClient: ParkerClient) {}

  public searchParkerNames(searchText: string): Observable<IAutocompleteItem[]> {
    const filter = new FilterDTO({
      isComplex: false,
      field: PARKER_FULL_NAME_FIELD,
      operator: FilterOperator.Contains,
      value: searchText,
    });

    return this.parkerClient.searchParkers(this.clientId ?? undefined, [filter], 0, 20, 'LastName', SortDirection.Ascending,
      false, false).pipe(map(result => {
      const seen = new Set<string>();
      const searchLower = searchText.toLowerCase();

      return result.items
        .map(p => `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim())
        .filter(name => name && !seen.has(name) && !!seen.add(name))
        .sort((a, b) => searchScore(b, searchLower) - searchScore(a, searchLower) || a.localeCompare(b))
        .map(name => ({ id: name, name }));
    }));
  }
}
